import httpInstances from '@/api/axiosInstance';
import type { MarketApps, WidgetV2 } from '@/features/Dashboard/types';
import type { Market, MarketDto, MarketsPageType } from '@/types/markets';
import { getInternalBasePath } from '@/utils/environmentPaths';
import { parseMarketComponent } from '@/utils/parseMarketComponent';
import { sanitizeName } from '@/utils/sanitizeName';

import type { MarketTabWidgets } from './markets.types';

export const marketsApi = {
  getMarket: async (marketId: string): Promise<Market> => {
    const { data } = await httpInstances.axiosInternalInstance.get<MarketDto>(
      `${getInternalBasePath()}markets/${marketId}`
    );

    const pages = data.pages.map(page => ({
      ...page,
      id: sanitizeName(page.name),
      components: page.components.map(component => {
        return parseMarketComponent(component, data?.version);
      })
    }));

    return {
      ...data,
      id: marketId,
      pages
    };
  },

  getMarketWidgets: async (marketId: string): Promise<MarketTabWidgets[]> => {
    const { data } = await httpInstances.axiosInternalInstance.get<any[]>(
      `${getInternalBasePath()}markets/${marketId}/widgets`
    );

    return data.map(tab => {
      const widgets: WidgetV2[] = [];
      for (const widget of tab.widgets) {
        if (widget.definition.tabs) {
          widget.definition.tabs.map((widgetTab: any) => {
            widgets.push({
              name: widgetTab.name,
              type: widget.type,
              definition: { ...widgetTab, layout: widget.definition?.layout, type: widget.type }
            } as unknown as WidgetV2);
          });
        } else {
          widgets.push(widget as unknown as WidgetV2);
        }
      }
      return { ...tab, widgets };
    }) as unknown as MarketTabWidgets[];
  },

  previewMarket: async (template: MarketApps): Promise<MarketsPageType | null> => {
    const { data } = await httpInstances.axiosInternalInstance.post<MarketDto>(
      `${getInternalBasePath()}markets/preview`,
      {
        version: 2,
        pages: [
          {
            name: '',
            components: template
          }
        ]
      }
    );

    const pages: MarketsPageType[] = data.pages.map(page => ({
      ...page,
      id: sanitizeName(page.name),
      components: page.components.map((component: any, componentIndex) => {
        const parsedComponent = parseMarketComponent(component, '2');
        if (parsedComponent.component?.type === 'tiles') {
          return {
            ...parsedComponent,
            component: {
              ...parsedComponent.component,
              tiles: parsedComponent.component.tiles.map((tile, index) => {
                const temp = template[0] as any;
                return {
                  ...tile,
                  id: temp.tiles[index].id
                };
              })
            }
          };
        }
        return {
          ...parsedComponent,
          id: template[componentIndex].id,
          tabs: parsedComponent.tabs?.map((tab, index) => {
            const temp = template[componentIndex] as any;
            return {
              ...tab,
              id: temp.tabs[index].id
            };
          })
        };
      })
    }));

    if (pages.length === 0) {
      return null;
    }

    return pages[0];
  }
};
